import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const NavigationBreadcrumbs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const breadcrumbMap = {
    '/dashboard': [{ label: 'Dashboard', path: '/dashboard' }],
    '/customer-management': [{ label: 'Customers', path: '/customer-management' }],
    '/bid-management': [{ label: 'Bids', path: '/bid-management' }],
    '/project-management': [{ label: 'Projects', path: '/project-management' }],
    '/project-phases': [
      { label: 'Projects', path: '/project-management' },
      { label: 'Phases', path: '/project-phases' }
    ],
    '/resource-management': [{ label: 'Resources', path: '/resource-management' }],
    '/analytics': [{ label: 'Analytics & Reporting', path: '/analytics' }],
    '/admin/settings': [
      { label: 'Admin', path: '/admin/settings' },
      { label: 'Settings', path: '/admin/settings' }
    ],
    '/admin/users': [
      { label: 'Admin', path: '/admin/settings' },
      { label: 'User Management', path: '/admin/users' }
    ],
    '/profile': [{ label: 'Profile', path: '/profile' }]
  };

  const breadcrumbs = breadcrumbMap?.[location?.pathname] || [];

  if (breadcrumbs?.length === 0) return null;

  return (
    <div className="breadcrumbs-container">
      <div className="breadcrumbs-wrapper">
        <nav aria-label="Breadcrumb">
          <ol className="breadcrumbs-list">
            <li className="breadcrumb-item">
              <button
                onClick={() => navigate('/dashboard')}
                className="breadcrumb-link"
                aria-label="Home"
              >
                <Icon name="Home" size={16} />
              </button>
            </li>

            {breadcrumbs?.map((crumb, index) => (
              <React.Fragment key={crumb?.path}>
                <li className="breadcrumb-separator">
                  <Icon name="ChevronRight" size={16} />
                </li>
                <li className="breadcrumb-item">
                  {index === breadcrumbs?.length - 1 ? (
                    <span className="breadcrumb-current">{crumb?.label}</span>
                  ) : (
                    <button
                      onClick={() => navigate(crumb?.path)}
                      className="breadcrumb-link"
                    >
                      {crumb?.label}
                    </button>
                  )}
                </li>
              </React.Fragment>
            ))}
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default NavigationBreadcrumbs;